import type { AsyncInvokeAgentProgressSnapshot, TenantImportAnswer, TenantImportResult } from '@einwert/valuation-api-client'

type TenantImportState = {
    step: 'file' | 'progress' | 'review' | 'done'
    file?: File
    progress?: AsyncInvokeAgentProgressSnapshot
    result?: TenantImportResult
    error?: string
    saveStatus: 'idle' | 'saving' | 'failed'
    importedCount: number
    answers: TenantImportAnswer[]
    confirmed: TenantImportAnswer[]
    clarificationRound: number
}

type TenantImportAction =
    | { type: 'select_file'; file?: File }
    | { type: 'answer'; answers: TenantImportAnswer[] }
    | { type: 'start_analysis' }
    | { type: 'progress'; progress: AsyncInvokeAgentProgressSnapshot }
    | { type: 'complete_analysis'; result: TenantImportResult; confirmed: TenantImportAnswer[]; round: number }
    | { type: 'fail_analysis'; error: string }
    | { type: 'start_save' }
    | { type: 'complete_save'; count: number }
    | { type: 'fail_save'; error: string }

export const initialTenantImportState: TenantImportState = {
    step: 'file',
    saveStatus: 'idle',
    importedCount: 0,
    answers: [],
    confirmed: [],
    clarificationRound: 0,
}

export function tenantImportReducer(state: TenantImportState, action: TenantImportAction): TenantImportState {
    switch (action.type) {
        case 'select_file':
            return { ...initialTenantImportState, file: action.file }
        case 'answer':
            return { ...state, answers: action.answers }
        case 'start_analysis':
            return { ...state, step: 'progress', progress: undefined, error: undefined, saveStatus: 'idle' }
        case 'progress':
            return { ...state, progress: action.progress }
        case 'complete_analysis':
            return {
                ...state,
                step: 'review',
                result: action.result,
                confirmed: action.confirmed,
                answers: [],
                clarificationRound: action.round,
            }
        case 'fail_analysis':
            return { ...state, step: state.result ? 'review' : 'file', error: action.error }
        case 'start_save':
            return { ...state, saveStatus: 'saving', error: undefined }
        case 'complete_save':
            return { ...state, step: 'done', saveStatus: 'idle', importedCount: action.count }
        case 'fail_save':
            return { ...state, saveStatus: 'failed', error: action.error }
    }
}
